// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"727":"0317f56c","940":"4df3a610"}[chunkId] + ".js";
};